import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn, FormControl } from '@angular/forms';

@Directive({
  selector: '[whiteSpaceValidator] [ngModel]',
  providers: [  
    {  
     provide: NG_VALIDATORS,  
     useExisting: WhiteSpaceValidator,  
     multi: true  
    }  
   ]  
})
export class WhiteSpaceValidator implements Validator {  
  validator: ValidatorFn;  
  constructor() {  
   this.validator = this.textValidator();  
  }  
  validate(c: FormControl) {  
   return this.validator(c);  
  }  
 
 textValidator(): ValidatorFn {  
   return (c: FormControl) => {  
    let isValid = /^\s+$/.test(c.value);  
    if (!isValid) {  
     return null;  
    } else {  
     return {  
      whiteSpaceValidator: {  
       valid: true  
      }  
     };  
    }  
   }  
  }  
 }


// WEBPACK FOOTER //
// ./src/app/shared/directives/whitespace-validator.directive.ts